interface ChatSurface {
  surface: string;
  surface_description: string;
}

const KIQ: ChatSurface = {
  surface: 'CHECKOUT_VERIFICATION_KIQ',
  surface_description: 'Customer is answering knowledge-based identity verification questions'
};
const BAV: ChatSurface = {
  surface: 'CHECKOUT_VERIFICATION_BAV',
  surface_description: 'Customer is verifying their bank account details for payment processing'
};
const INCOME: ChatSurface = {
  surface: 'CHECKOUT_VERIFICATION_INCOME',
  surface_description: 'Customer is providing income documentation for financing verification'
};
const ADDRESS: ChatSurface = {
  surface: 'CHECKOUT_VERIFICATION_ADDRESS',
  surface_description:
    'Customer is confirming or updating their address for delivery and registration'
};
const TRADE: ChatSurface = {
  surface: 'CHECKOUT_VERIFICATION_TRADE',
  surface_description: 'Customer is completing verification steps for their trade-in vehicle'
};
const ADDITIONAL_INCOME: ChatSurface = {
  surface: 'CHECKOUT_VERIFICATION_ADDITIONAL_INCOME',
  surface_description:
    'Customer is providing additional income documentation required for high-risk financing approval'
};

export const CHAT_SURFACE_MAPPINGS: Record<string, ChatSurface> = {
  'down-payment': {
    surface: 'CHECKOUT_DOWN_PAYMENT',
    surface_description:
      'Customer is selecting their down payment amount and payment method for their vehicle purchase'
  },
  'autopay-enrollment': {
    surface: 'CHECKOUT_AUTOPAY_ENROLLMENT',
    surface_description:
      'Customer is choosing whether to enroll in autopay for their monthly car payments'
  },
  'buyer-identity': {
    surface: 'CHECKOUT_BUYER_IDENTITY',
    surface_description:
      'Customer is verifying their identity by providing personal identification details'
  },
  'co-signer-identity': {
    surface: 'CHECKOUT_CO_SIGNER_IDENTITY',
    surface_description:
      'Customer is providing identity details for their co-signer on the vehicle purchase'
  },
  _verification: {
    surface: 'CHECKOUT_VERIFICATION',
    surface_description:
      'Customer is completing final verification steps before their purchase can be submitted'
  },
  'transfer-select-slot': {
    surface: 'CHECKOUT_TRANSFER_SELECT_SLOT',
    surface_description: 'Customer is scheduling their vehicle delivery or pickup date and time'
  },
  'complete-purchase': {
    surface: 'CHECKOUT_COMPLETE_PURCHASE',
    surface_description:
      'Customer is on the final step reviewing and confirming their vehicle purchase order'
  },

  'identity-verification': KIQ,
  bav: BAV,
  'bank-account-verification': BAV,
  income: INCOME,
  'income-verification': INCOME,
  'income-information': INCOME,
  address: ADDRESS,
  'address-verification': ADDRESS,
  'residency-information': ADDRESS,
  'trade-verification': TRADE,
  'trade-documentation': TRADE,
  'additional-income': ADDITIONAL_INCOME
};

export function getChatSurface(stepUrl: string): ChatSurface | null {
  return CHAT_SURFACE_MAPPINGS[stepUrl] ?? null;
}
